import classNames from 'classnames';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import React from 'react';
import Link from '/@/components/link';
import settings from '/@/core/settings';
import { _ } from '/@/locale';
import styles from './styles.module.css';

@autobind
export default class ErrorView extends React.Component {
    static propTypes = {
        errorCode: PropTypes.number,
    };

    static defaultProps = {
        errorCode: 404,
    };

    render() {
        const errors = {
            404: {
                code: 404,
                title: _('Página no encontrada'),
                description: _('La página que estás buscando no existe.'),
            },
        };
        const error = errors[this.props.errorCode];

        return (
            <div className={classNames(styles.root, styles[`error-${error.code}`])}>
                <h2 className={styles.subtitle}>{_('¡Ups! Algo salió mal...')}</h2>
                <div
                    className={classNames(
                        styles.image,
                        styles[
                            settings.app.theme === 'expertobayer'
                                ? `error-${error.code}-expertobayer`
                                : `error-${error.code}`
                        ]
                    )}
                />
                <h3 className={styles.title}>{error.title}</h3>
                <p className={styles.description}>{error.description}</p>
                <Link to='NewHome'>
                    <button className={styles.button}>{_('Inicio')}</button>
                </Link>
            </div>
        );
    }
}
